// Shared ordering for the desktop sidebar and the mobile More menu.
const sections = [
  { title: "Overview", paths: ["/dashboard"] },
  { title: "Event work", paths: ["/events", "/clock", "/tasks", "/flights"] },
  { title: "My details", paths: ["/profile", "/availability", "/documents", "/training"] },
  { title: "Team management", paths: ["/staff", "/document-management", "/notification-settings"] },
];

export function groupNavigationItems(items) {
  const assignedPaths = new Set([...sections.flatMap(section => section.paths), "/faulty-equipment", "/uniform-requests"]);
  return [
    ...sections.map(section => ({
      title: section.title,
      items: section.paths.flatMap(path => items.filter(item => item.url === path)),
    })),
    { title: "Equipment & uniform", items: items.filter(item => item.external || ["/faulty-equipment", "/uniform-requests"].includes(item.url)) },
    {
      title: "Help & settings",
      items: items.filter(item => !item.external && !assignedPaths.has(item.url)),
    },
  ].filter(section => section.items.length > 0);
}
